import React from "react";
import { Image } from "react-native";

interface Props { width?: number; height?: number }

export default function NotchShape({ width = 80, height = 124 }: Props) {
  return <Image source={require("../../assets/icons/notch.png")} style={{ width, height }} resizeMode="stretch" />;
}
